<section>
  <p [innerHTML]="description | translate" *ngIf="showDescription"></p>
  <h1 [innerHTML]="title | translate"></h1>
</section>
